// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"443":"about","962":"jump"}[chunkId] || chunkId) + "-legacy." + {"99":"e1ddf7c8","443":"2bde4020","962":"f3662de4"}[chunkId] + ".js";
};